import { Provider } from '@indigohive/cogfy-providers'
import { PlusIcon } from 'lucide-react'
import { Fragment } from 'react'
import { AddFacebookButton, AddMetaMarketingApiButton } from '../../pages/WorkspaceConnectionsPage/components'
import { AddAwsButton } from '../../pages/WorkspaceConnectionsPage/components/AddAwsButton'
import { AddGithubButton } from '../../pages/WorkspaceConnectionsPage/components/AddGithubButton'
import { AddGoogleCalendarButton } from '../../pages/WorkspaceConnectionsPage/components/AddGoogleCalendarButton'
import { AddGoogleDriveButton } from '../../pages/WorkspaceConnectionsPage/components/AddGoogleDriveButton'
import { AddHerokuButton } from '../../pages/WorkspaceConnectionsPage/components/AddHerokuButton'
import { AddHttpButton } from '../../pages/WorkspaceConnectionsPage/components/AddHttpButton'
import { AddJiraButton } from '../../pages/WorkspaceConnectionsPage/components/AddJiraButton'
import { AddPostgresqlButton } from '../../pages/WorkspaceConnectionsPage/components/AddPostgresqlButton'
import { Button } from '../Button'
import { AddRdStationButton } from '../../pages/WorkspaceConnectionsPage/components/AddRdStationButton'
import { AddAzureAdButton } from '../../pages/WorkspaceConnectionsPage/components/AddAzureAdButton'

type CreateConnectionButtonProps = {
  provider: Provider
  children: string
  onCreateConnectionClick?: () => void
  onSuccess?: () => void
  className?: string
}

export function CreateConnectionButton (props: CreateConnectionButtonProps) {
  const { provider, className, onSuccess } = props

  const text = props.children

  return (
    <Fragment>
      {provider?.name === 'aws' && (<AddAwsButton onSuccess={onSuccess} className={className}>{text}</AddAwsButton>)}
      {provider?.name === 'azureAd' && (<AddAzureAdButton onSuccess={onSuccess} className={className}>{text}</AddAzureAdButton>)}
      {provider?.name === 'github' && (<AddGithubButton onSuccess={onSuccess} className={className}>{text}</AddGithubButton>)}
      {provider?.name === 'googleCalendar' && (<AddGoogleCalendarButton className={className}>{text}</AddGoogleCalendarButton>)}
      {provider?.name === 'googleDrive' && (<AddGoogleDriveButton className={className}>{text}</AddGoogleDriveButton>)}
      {provider?.name === 'heroku' && (<AddHerokuButton onSuccess={onSuccess} className={className}>{text}</AddHerokuButton>)}
      {provider?.name === 'http' && (<AddHttpButton onSuccess={onSuccess} className={className}>{text}</AddHttpButton>)}
      {provider?.name === 'jira' && (<AddJiraButton onSuccess={onSuccess} className={className}>{text}</AddJiraButton>)}
      {provider?.name === 'metaMarketingApi' && (<AddMetaMarketingApiButton onSuccess={onSuccess} className={className}>{text}</AddMetaMarketingApiButton>)}
      {provider.name === 'postgresql' && (<AddPostgresqlButton onSuccess={onSuccess} className={className}>{text}</AddPostgresqlButton>)}
      {provider?.name === 'rdStation' && (<AddRdStationButton onSuccess={onSuccess} className={className}>{text}</AddRdStationButton>)}
      {provider?.name === 'whatsapp' && (<AddFacebookButton onSuccess={onSuccess} className={className}>{text}</AddFacebookButton>)}
      {props.onCreateConnectionClick && (
        <Button
          className={className}
          size='sm'
          onClick={() => {
            props.onCreateConnectionClick?.()
          }}
        >
          <PlusIcon size={14}/>{props.children}
        </Button>
      )}
    </Fragment>
  )
}
